// extracted by mini-css-extract-plugin
export default {"icon":"OperationsPage_icon__OAjxi","filters":"OperationsPage_filters__Y4xgY"};